import React, { useState, useMemo, useEffect } from "react";
import { IoEyeOutline } from "react-icons/io5";
import { RiDeleteBinLine } from "react-icons/ri";
import { BiEditAlt, BiIdCard } from "react-icons/bi";
import { RiTruckLine } from "react-icons/ri";
import CheckMark from "../../assets/Icons/final approval checker.svg";
import DLTIcon from "../../assets/Icons/DLT.svg";
import "../../css/MasterTable.css";
import Loader from "../Loader/Loader";
import { GrValidate, GrAttachment, GrRedo } from "react-icons/gr";
import { BsClipboardData } from "react-icons/bs";
import reload from "../../assets/Icons/reload-filter.svg";
import Pagination from "./Pagination";
import TableDropDownButtonIcon from "../../assets/Icons/TableDropDownButtonIcon.svg";
import TableDropDownOpenButton from "../../assets/Icons/TableDropDownOpenButton.svg";
import ExcelExport from "../../assets/Icons/Excel Export.svg";
import Routes from "../routes/Routes";
import { useLocation, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { FiEye } from "react-icons/fi";
import DltHoverIcon from "../../assets/Icons/DLT_hover.svg";
import AddIcon from "../../assets/Icons/AddIcon.svg";
import CheckMarkHoverIcon from "../../assets/Icons/final approval checker_hover.svg";
import { ICONS } from "../../assets/Icons";
import GetAppIcon from "@mui/icons-material/GetApp";
import { motion } from "framer-motion";
import FilterImg from "../../assets/Images/Funnel.svg";
import { RiLockLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import Button from "../customButton/Button";
import DetailModal from "./DetailModal";
import EmailStatusModal from "./EmailStatusModal";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import ReplayIcon from "@mui/icons-material/Replay";
import { Tooltip } from "@mui/material";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { RiNotification3Line } from "react-icons/ri";
import { FaBoxOpen } from "react-icons/fa";
import { GrUserManager } from "react-icons/gr";
import { FiCheckCircle } from "react-icons/fi";
import { FaBox } from "react-icons/fa";
import { TbRoute } from "react-icons/tb";
import { FaHome } from "react-icons/fa";
import { TbPrinter, TbFileInvoice } from "react-icons/tb";
import { TbX } from "react-icons/tb";
import { GrSend } from "react-icons/gr";
import { TbMapPin } from "react-icons/tb";
import { GrDeliver } from "react-icons/gr";
import { FaTruck } from "react-icons/fa";
import { TbTruckDelivery } from "react-icons/tb";
import { TbDownload } from "react-icons/tb";
import EditNoteIcon from "@mui/icons-material/EditNote";

const MasterTable = ({
  optionRefs,
  data,
  headers,
  handleAction,
  filterFields,
  entityType,
  headerToKeyMap,
  loading,
  handleAuth,
  noData,
  pageDetails,
  handleKey,
  RechargeKey,
  BillPaymentKey,
  CourierKey,
  totalRecord,
  pageSize,
  setPageSize,
  currentPage,
  fetchNextData,
  setCurrentPage,
  setRowData,
  hideAction,
  handleAuditData,
  openModalSms,
  openModalSmsDown,
  openModalRcs,
  openModalRcsDown,
  openModalFilter,
  handleReset,
  filterData,
  hideFilterControls = false,
  fetchData,
  handleRcsKey,
  openModalIpWhit,
  handleProductDetails,
  btnName,
  openModalRcsNew,
  handleItemsIncludedClick,
  handleExport,
  exportLoading,
  headerInfo,
  modalBtnName,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [sortOrder, setSortOrder] = useState("");
  const [sortFieldData, setSortFieldData] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [hoveredDLTId, setHoveredDLTId] = useState(null);
  const [hoveredCheckerId, setHoveredCheckerId] = useState(null);
  const [detailModal, setDetailModal] = useState(false);
  // Account whose mail status is open: { code, title }
  const [emailStatusFor, setEmailStatusFor] = useState(null);
  const [modalText, setModalText] = useState("");
  const [modalHeading, setModalHeading] = useState("");

  const userRole = sessionStorage.getItem("userRole");
  const isSidebarOpen = useSelector((state) => state.sidebar.isSidebarOpen);
  const hierarchyType = useSelector(
    (state) => state.balance.balance?.wallet?.hierarchyType,
  );

  console.log("Hierarchy Type:", hierarchyType);

  const { PROTECTED_ROUTES } = Routes();
  const location = useLocation();
  const { menu } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.auth);

  const isLMBPLogin = user?.data?.userProfile === "CUSTOMER";
  const isHubLogin = user?.data?.userProfile === "HUB";
  const isFranchiseLogin = user?.data?.userProfile === "FRANCHISE";
  const isAdminMakerLogin = user?.data?.userProfile === "ADMK";
  const isOperationsLogin = user?.data?.userProfile === "OPERATION";

  const array1 = menu;

  const array =
    menu !== null &&
    menu !== undefined &&
    menu !== "" &&
    array1?.split("").map((char) => parseInt(char));

  // Check if filters are applied
  const hasActiveFilters = useMemo(() => {
    if (!filterData) return false;
    return Object.values(filterData).some((value) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== "" && value !== null && value !== undefined;
    });
  }, [filterData]);

  // Update showFilters based on active filters
  useEffect(() => {
    if (hasActiveFilters) {
      setShowFilters(true);
    }
  }, [hasActiveFilters, data, currentPage]);

  const CompanyformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.customerCode) {
      activeFilters.push(`LMBP Id: ${filterData.customerCode}`);
    }
    if (filterData.name) {
      activeFilters.push(`LMBP Name: ${filterData.name}`);
    }
    if (filterData.gstNumber) {
      activeFilters.push(`GST No.: ${filterData.gstNumber}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.firstContactPersonMobileNo) {
      activeFilters.push(`Mobile No: ${filterData.firstContactPersonMobileNo}`);
    }
    if (filterData.companyPanNumber) {
      activeFilters.push(`PAN No: ${filterData.companyPanNumber}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const FranchiseformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.franchiseCode && !filterData.franchiseName) {
      activeFilters.push(`Franchise Id: ${filterData.franchiseCode}`);
    }
    if (filterData.franchiseName) {
      activeFilters.push(`Franchise Name: ${filterData.franchiseName}`);
    }
    if (filterData.gstNumber) {
      activeFilters.push(`GST No.: ${filterData.gstNumber}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.primaryContactMobile) {
      activeFilters.push(`Mobile No: ${filterData.primaryContactMobile}`);
    }
    if (filterData.companyPanNumber) {
      activeFilters.push(`PAN No: ${filterData.companyPanNumber}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const CourierHubformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.customerCode) {
      activeFilters.push(`Company Id: ${filterData.customerCode}`);
    }
    if (filterData.hubName) {
      activeFilters.push(`Hub Name: ${filterData.hubName}`);
    }
    if (filterData.gstNumber) {
      activeFilters.push(`GST No.: ${filterData.gstNumber}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.firstContactPersonMobileNo) {
      activeFilters.push(`Mobile No: ${filterData.firstContactPersonMobileNo}`);
    }
    if (filterData.companyPanNumber) {
      activeFilters.push(`PAN No: ${filterData.companyPanNumber}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const UserformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.userId) {
      activeFilters.push(`User Id: ${filterData.userId}`);
    }
    if (filterData.userProfile) {
      activeFilters.push(`Profile: ${filterData.userProfile?.label}`);
    }
    if (filterData.status) {
      activeFilters.push(`Status: ${filterData.status?.label}`);
    }
    if (filterData.name) {
      activeFilters.push(`Company ID: ${filterData.name}`);
    }
    if (filterData.mobileNo) {
      activeFilters.push(`Mobile No: ${filterData.mobileNo}`);
    }
    if (filterData.emailId) {
      activeFilters.push(`Email Id: ${filterData.emailId}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const MWalletformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.userId) {
      activeFilters.push(`User Id: ${filterData.userId}`);
    }
    if (filterData.customerId) {
      activeFilters.push(`Customer Id: ${filterData.customerId}`);
    }
    if (filterData.profile) {
      activeFilters.push(`Profile: ${filterData.profile?.label}`);
    }
    if (filterData.fromAmount) {
      activeFilters.push(`From Amount: ${filterData.fromAmount}`);
    }
    if (filterData.toAmount) {
      activeFilters.push(`To Amount: ${filterData.toAmount}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const ReportformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData?.companyCode) {
      activeFilters.push(`Company Code: ${filterData?.companyCode}`);
    }
    if (filterData?.fromDate) {
      activeFilters.push(`Start Date: ${filterData?.fromDate}`);
    }
    if (filterData?.toDate) {
      activeFilters.push(`End Date: ${filterData?.toDate}`);
    }
    if (filterData?.fromAmount) {
      activeFilters.push(`Start Amount: ${filterData?.fromAmount}`);
    }
    if (filterData?.toAmount) {
      activeFilters.push(`End Amount: ${filterData?.toAmount}`);
    }

    if (filterData?.billerCategory) {
      activeFilters.push(`Service Type: ${filterData?.billerCategory?.label}`);
    }

    if (filterData?.billerName) {
      activeFilters.push(`Biller Name: ${filterData?.billerName}`);
    }

    if (filterData?.billerStatus?.length > 0) {
      const statusLabels = {
        P: "Pending",
        T: "Processing",
        S: "Success",
        F: "Failed",
      };

      const selectedStatuses = filterData?.billerStatus
        .map((status) => statusLabels[status])
        .filter(Boolean);

      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const OrderformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.retailerName) {
      activeFilters.push(`LMBP Name: ${filterData.retailerName}`);
    }
    if (filterData.consigneeName) {
      activeFilters.push(`Consignee Name: ${filterData.consigneeName}`);
    }
    if (filterData.consigneeMobile) {
      activeFilters.push(`Consignee Mobile: ${filterData.consigneeMobile}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.ourWaybillNumber) {
      activeFilters.push(`Ewaybill Number: ${filterData.ourWaybillNumber}`);
    }
    if (filterData.expressType) {
      activeFilters.push(`Express Type: ${filterData.expressType}`);
    }
    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const BuyStationaryformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.itemName) {
      activeFilters.push(`Stationary Name: ${filterData.itemName}`);
    }
    if (filterData.createdBy && filterData.createdBy.trim()) {
      activeFilters.push(`Created By: ${filterData.createdBy.trim()}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (filterData.status) {
      const statusLabels = {
        PENDING: "Pending",
        APPROVED: "Approved",
        REJECTED: "Rejected",
        CANCELLED: "Cancelled",
      };
      activeFilters.push(
        `Status: ${statusLabels[filterData.status] || filterData.status}`,
      );
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const DeliveryformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.fullName) {
      activeFilters.push(`Full Name: ${filterData.fullName}`);
    }
    if (filterData.mobileNo) {
      activeFilters.push(`Contact No: ${filterData.mobileNo}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(
        `Status: ${
          Array.isArray(filterData.status)
            ? filterData.status.join(", ")
            : filterData.status
        }`
      );
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const OrderCourierformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.companyId) {
      activeFilters.push(`Bag No: ${filterData.companyId}`);
    }
    if (filterData.status && (Array.isArray(filterData.status) ? filterData.status.length > 0 : true)) {
      activeFilters.push(
        `Status: ${
          Array.isArray(filterData.status)
            ? filterData.status.join(", ")
            : filterData.status
        }`
      );
    }
    if (filterData.createdDate) {
      activeFilters.push(`Created Date: ${filterData.createdDate}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const BagCourierformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.bagNo) {
      activeFilters.push(`Bag No: ${filterData.bagNo}`);
    }
    if (filterData.createdBy) {
      activeFilters.push(`Created By: ${filterData.createdBy}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const PickupAddressformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData?.addressTitle) {
      activeFilters.push(`Address Title: ${filterData.addressTitle}`);
    }
    if (filterData?.phone) {
      activeFilters.push(`Phone No: ${filterData.phone}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const RateCardformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData?.rateCardId) {
      activeFilters.push(`Rate Card Id: ${filterData.rateCardId}`);
    }
    if (filterData?.rateCardName) {
      activeFilters.push(`Rate Card Name: ${filterData.rateCardName}`);
    }
    if (filterData?.status) {
      activeFilters.push(`Status: ${filterData.status}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const GenerateStickerformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData?.requestedBy) {
      activeFilters.push(`Requested by: ${filterData.requestedBy}`);
    }
    if (filterData?.mobile) {
      activeFilters.push(`Mobile No: ${filterData.mobile}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const LedgerformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData?.companyId) {
      activeFilters.push(`Company ID: ${filterData?.companyId}`);
    }
    if (filterData?.fromAmount) {
      activeFilters.push(`Start Amount: ${filterData?.fromAmount}`);
    }
    if (filterData?.toAmount) {
      activeFilters.push(`End Amount: ${filterData?.toAmount}`);
    }
    if (filterData?.fromDate) {
      activeFilters.push(`Start Date: ${filterData?.fromDate}`);
    }
    if (filterData?.toDate) {
      activeFilters.push(`End Date: ${filterData?.toDate}`);
    }

    if (filterData?.drcr) {
      activeFilters.push(`Debit/Credit: ${filterData?.drcr?.label}`);
    }

    if (filterData?.txnType?.length > 0) {
      activeFilters.push(`Transaction Types: ${filterData.txnType.join(", ")}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const LedgerReportformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData?.walletNumber?.trim()) {
      activeFilters.push(`Wallet Number: ${filterData.walletNumber.trim()}`);
    }

    if (filterData?.walletUserName?.trim()) {
      activeFilters.push(`Wallet Name: ${filterData.walletUserName.trim()}`);
    }

    if (filterData?.batchNumber?.trim()) {
      activeFilters.push(`Batch Number: ${filterData.batchNumber.trim()}`);
    }

    // Add Dr/Cr filter display - values "DR" or "CR"
    if (filterData?.drCr?.trim()) {
      const displayValue =
        filterData.drCr.trim() === "DR" ? "Debit (DR)" : "Credit (CR)";
      activeFilters.push(`Dr/Cr: ${displayValue}`);
    }

    // Add Payment Mode filter display - values "WALLET" or "UPI"
    if (filterData?.paymentMode?.trim()) {
      const displayValue =
        filterData.paymentMode.trim() === "WALLET" ? "Wallet" : "UPI";
      activeFilters.push(`Payment Mode: ${displayValue}`);
    }

    if (filterData?.fromDate) {
      const [year, month, day] = filterData.fromDate.split("-");
      if (day && month && year) {
        activeFilters.push(`From Date: ${day}-${month}-${year}`);
      } else {
        activeFilters.push(`From Date: ${filterData.fromDate}`);
      }
    }

    if (filterData?.toDate) {
      const [year, month, day] = filterData.toDate.split("-");
      if (day && month && year) {
        activeFilters.push(`To Date: ${day}-${month}-${year}`);
      } else {
        activeFilters.push(`To Date: ${filterData.toDate}`);
      }
    }

    if (filterData?.createdBy?.trim()) {
      activeFilters.push(`Created By: ${filterData.createdBy.trim()}`);
    }

    if (filterData?.ewaybillNumber?.trim()) {
      activeFilters.push(
        `Ewaybill Number: ${filterData.ewaybillNumber.trim()}`,
      );
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const NotificationformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      ARRIVED_AT_HUB: "Arrived at Hub",
      HANDED_OVER_TO_DELIVERY_BOY: "Handed Over to Delivery Boy",
      ALLOCATED_TO_DELIVERY_BOY: "Allocated to Delivery Boy",
      NOTIFIED_HUB: "Notified Hub",
      OPENED_AT_HUB: "Opened at Hub",
    };

    if (filterData?.bagNo?.trim()) {
      activeFilters.push(`Bag No: ${filterData.bagNo.trim()}`);
    }

    if (filterData?.status) {
      activeFilters.push(
        `Status: ${statusLabels[filterData.status] || filterData.status}`,
      );
    }

    if (filterData?.fromDate) {
      const [year, month, day] = filterData.fromDate.split("-");
      if (day && month && year) {
        activeFilters.push(`From Date: ${day}-${month}-${year}`);
      } else {
        activeFilters.push(`From Date: ${filterData.fromDate}`);
      }
    }

    if (filterData?.toDate) {
      const [year, month, day] = filterData.toDate.split("-");
      if (day && month && year) {
        activeFilters.push(`To Date: ${day}-${month}-${year}`);
      } else {
        activeFilters.push(`To Date: ${filterData.toDate}`);
      }
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const CourierformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.companyId) {
      activeFilters.push(`Company Id: ${filterData.companyId}`);
    }
    if (filterData.retailerCode) {
      activeFilters.push(`LMBP Code: ${filterData.retailerCode}`);
    }
    if (filterData.pincode) {
      activeFilters.push(`Pincode: ${filterData.pincode}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.status?.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const SMSformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      C: "Delivered",
      P: "Pending",
      F: "Failed",
      E: "Exception",
      S: "Send",
    };

    if (filterData.userCode && userRole !== "ADMK") {
      activeFilters.push(`Company Id: ${filterData.userCode}`);
    }
    if (filterData.customerName && userRole === "ADMK") {
      activeFilters.push(`Company Name: ${filterData.customerName}`);
    }
    if (filterData.mobileNo) {
      activeFilters.push(`Mobile No: ${filterData.mobileNo}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status])
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.operator?.length > 0) {
      activeFilters.push(`Operator: ${filterData.operator.join(", ")}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const BuySMSformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      C: "Completed",
      P: "Pending",
      F: "Failed",
      T: "Timeout",
      S: "Send",
    };

    const serviceType = [
      { value: "BUY_SMS", label: "Buy SMS" },
      { value: "BUY_RCS", label: "Buy RCS" },
      { value: "TOPUP_SMS", label: "Top up SMS" },
      { value: "TOPUP_RCS", label: "Top up RCS" },
    ];

    if (filterData.vendorName) {
      activeFilters.push(`Vendor Name: ${filterData.vendorName}`);
    }

    if (filterData.txnsType) {
      const txnObj = serviceType.find((s) => s.value === filterData.txnsType);
      if (txnObj) {
        activeFilters.push(`Transaction Type: ${txnObj.label}`);
      }
    }

    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status])
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }

    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }

    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const TopupSMSformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const serviceType = [
      { value: "TopUp_SMS", label: "Top Up SMS" },
      { value: "TOPUP_RCS", label: "Top Up RCS" },
    ];

    if (filterData.actionType) {
      const txnObj = serviceType.find((s) => s.value === filterData.actionType);
      if (txnObj) {
        activeFilters.push(`Action Type: ${txnObj.label}`);
      }
    }

    if (filterData.maxTxnAmount) {
      activeFilters.push(`From Amount: ₹${filterData.maxTxnAmount}`);
    }

    if (filterData.minTxnAmount) {
      activeFilters.push(`To Amount: ₹${filterData.minTxnAmount}`);
    }

    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }

    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const RCSformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      // SENT: "Sent",
      FAILED: "Failed",
      SENT_TO_CUSTOMER: "Sent to Customer",
      DECLINED: "Declined",
      UNREACHABLE_USER: "Unrechable User",
      SEND_MESSAGE_FAILURE: "Send Message Failure",
      SEND_MESSAGE_SUCCESS: "Send Message Success",
      MESSAGE_DELIVERED: "Message Delivered",
      MESSAGE_READ: "Message Read",
      // DELIVERED: "Delivered",
      // ACCEPTED: "Accepted",
      // READ: "Read",
    };

    if (filterData.customerName && userRole === "ADMK") {
      activeFilters.push(`Company Name: ${filterData.customerName}`);
    }

    if (filterData.companyId && userRole !== "ADMK") {
      activeFilters.push(`Company ID: ${filterData.companyId}`);
    }
    if (filterData.mobileNum) {
      activeFilters.push(`Mobile No: ${filterData.mobileNum}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status] || status)
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const CourierHubFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.customerCode) {
      activeFilters.push(
        `${user?.data?.userProfile === "HUB" ? "Hub Id:" : "LMBP Id:"}${
          filterData.customerCode
        }`,
      );
    }

    if (filterData?.franchiseCode) {
      activeFilters.push(`Franchise Id: ${filterData.franchiseCode}`);
    }

    if (filterData.name) {
      activeFilters.push(`LMBP Name: ${filterData.name}`);
    }

    if (filterData.hubName) {
      activeFilters.push(`Hub Name: ${filterData.hubName}`);
    }

    if (filterData.franchiseName) {
      activeFilters.push(`Franchise Name: ${filterData.franchiseName}`);
    }

    if (filterData.gstNumber) {
      activeFilters.push(`GST No: ${filterData.gstNumber}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.companyPanNumber) {
      activeFilters.push(`Comp. Pan: ${filterData.companyPanNumber}`);
    }
    if (filterData.firstContactPersonMobileNo) {
      activeFilters.push(`Mobile No: ${filterData.firstContactPersonMobileNo}`);
    }

    if (filterData.primaryContactMobile) {
      activeFilters.push(`Mobile No: ${filterData.primaryContactMobile}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const CustomerEnquiriesformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.type) {
      activeFilters.push(`Type: ${filterData.type}`);
    }

    if (filterData.fullName) {
      activeFilters.push(`Name: ${filterData.fullName}`);
    }

    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const PaymentHistoryFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      INITIATED: "Initiated",
      SUCCESS: "Success",
      FAILED: "Failed",
    };

    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status] || status)
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }

    if (filterData.paymentMethod) {
      activeFilters.push(`Payment Method: ${filterData.paymentMethod}`);
    }

    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const ChargeMasterFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.source) {
      activeFilters.push(`Category: ${filterData.source}`);
    }

    if (filterData.express) {
      activeFilters.push(`Express Type: ${filterData.express}`);
    }

    if (filterData.rateCardName) {
      activeFilters.push(`Charge Type: ${filterData.rateCardName}`);
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const BulkUploadformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      COMPLETED: "Completed",
      PROCESSING: "Processing",
    };

    if (filterData.sendorId) {
      activeFilters.push(`Sender Id: ${filterData.sendorId}`);
    }
    if (filterData.templateId) {
      activeFilters.push(`Template Id: ${filterData.templateId}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status] || status)
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const VendorformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      ACTIVE: "Active",
      INACTIVE: "In-Active",
      BLOCKED: "Blocked",
    };

    if (filterData.vendorName) {
      activeFilters.push(`Vendor Name: ${filterData.vendorName}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status] || status)
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.smsType?.label) {
      activeFilters.push(`SMS Type: ${filterData.smsType.label}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const RoleformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      ACTIVE: "Active",
      INACTIVE: "In-Active",
      BLOCKED: "Blocked",
    };

    if (filterData.userProfile?.label) {
      activeFilters.push(`User Profile: ${filterData.userProfile.label}`);
    }
    if (filterData.roleName) {
      activeFilters.push(`Role Name: ${filterData.roleName}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status] || status)
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const VendorTxtHistoryformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      C: "Success",
      F: "Failed",
    };

    const serviceType = [
      { value: "BUY_SMS", label: "Buy SMS" },
      { value: "BUY_RCS", label: "Buy RCS" },
      { value: "TOPUP_SMS", label: "Top up SMS" },
      { value: "TOPUP_RCS", label: "Top up RCS" },
    ];

    if (filterData.vendorName) {
      activeFilters.push(`Vendor Name: ${filterData.vendorName}`);
    }
    if (filterData.vendorId) {
      activeFilters.push(`Vendor Id: ${filterData.vendorId}`);
    }
    if (filterData.txnsType) {
      const txnObj = serviceType.find((s) => s.value === filterData.txnsType);
      if (txnObj) {
        activeFilters.push(`Transaction Type: ${txnObj.label}`);
      }
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status])
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const BagformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.bagNo) {
      activeFilters.push(`Bag No: ${filterData.bagNo}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const shouldRenderCreate = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[0]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderEdit = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[1]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderDelete = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[2]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderAuth = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[3]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderAUDIT = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[4]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderDLT = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[5]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderChecker = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[6]?.arr == 1;
    } else {
      return false;
    }
  });

  // Toggle row expansion for mobile view
  const toggleRowExpansion = (id) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const filteredData = useMemo(() => {
    if (!data) {
      return [];
    }

    if (!searchTerm || searchTerm.trim() === "") {
      return data;
    }

    const filtered = data?.filter((item) => {
      const matchesSearch = filterFields.some((field) => {
        const value = item[field];

        if (value === null || value === undefined) {
          return false;
        }

        const stringValue = String(value).toLowerCase();
        const searchLower = searchTerm.toLowerCase();

        const matches = stringValue.includes(searchLower);
        return matches;
      });
      return matchesSearch;
    });

    return filtered;
  }, [searchTerm, data, filterFields]);

  const sortedData = useMemo(() => {
    if (!filteredData || !sortFieldData) return filteredData;

    return [...filteredData].sort((a, b) => {
      const fieldA = a[sortFieldData]?.toString().toLowerCase();
      const fieldB = b[sortFieldData]?.toString().toLowerCase();

      if (fieldA < fieldB) return sortOrder === "asc" ? -1 : 1;
      if (fieldA > fieldB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortFieldData, sortOrder]);

  const isNumber = (value) => !isNaN(value) && typeof value === "number";

  const isNumericColumn = (header) => {
    const dataKey = headerToKeyMap[header];
    return data?.some((item) => isNumber(item[dataKey]));
  };

  const handleSortChange = (e, field) => {
    setSortOrder(e.target.value);
    setSortFieldData(field);
  };

  const toggleFilters = () => {
    setShowFilters((prevState) => !prevState);
  };

  const handleToggle = () => {
    toggleFilters();
    if (typeof handleReset === "function") {
      handleReset();
    }
    if (typeof fetchData === "function") {
      fetchData();
    }
  };

  const showFullContent = (content, key) => {
    let heading = "";
    let displayContent = content;
    if (key === "utrNo") {
      heading = "UTR Number";
    } else if (key === "responseDescription" || key === "response") {
      heading = "Response Description";
    } else if (key === "address") {
      heading = "Address";
    } else if (key === "ewaybillNumber") {
      heading = "E-Waybill Number";
    } else if (key === "narration") {
      heading = "Narration";
    } else if (key === "remark") {
      heading = "Remark";
    } else {
      heading = key
        ?.replace(/([A-Z])/g, " $1")
        ?.replace(/^./, (c) => c.toUpperCase());
    }
    setModalHeading(heading);
    setModalText(displayContent);
    setDetailModal(true);
  };

  const getActionItems = (item) => {
    if (entityType === "CustomerEnquiries") return [];
    const actions = [];

    if (entityType === "Vendor") {
      actions.push({
        icon: (
          <span
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginRight: "10px",
            }}
          >
            #
          </span>
        ),
        label: "Sequence",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "sequence");
        },
      });
    }

    if ((shouldRenderEdit || entityType === "Delivery") && entityType !== "BuyStationary") {
      if (entityType !== "Top-up SMS Request") {
        actions.push({
          icon: <BiEditAlt style={{ marginRight: "10px" }} />,
          label: "Edit",
          onClick: (e) => {
            e.stopPropagation();
            handleAction(item, "modify");
          },
        });
      } else {
        actions.push({
          icon: (
            <img
              src={
                hoveredCheckerId === item.id ? CheckMarkHoverIcon : CheckMark
              }
              alt="CheckMark"
              style={{ height: "14px", cursor: "pointer", marginRight: "10px" }}
              onMouseEnter={() => setHoveredCheckerId(item.id)}
              onMouseLeave={() => setHoveredCheckerId(null)}
            />
          ),
          label: "Checker",
          onClick: (e) => {
            e.stopPropagation();
            handleAuth(item, "modify");
          },
        });
      }
    }

    if (shouldRenderChecker) {
      actions.push({
        icon: (
          <img
            src={hoveredCheckerId === item.id ? CheckMarkHoverIcon : CheckMark}
            alt="CheckMark"
            style={{ height: "14px", cursor: "pointer", marginRight: "10px" }}
            onMouseEnter={() => setHoveredCheckerId(item.id)}
            onMouseLeave={() => setHoveredCheckerId(null)}
          />
        ),
        label: "Checker",
        onClick: (e) => {
          e.stopPropagation();
          handleAuth(item, "check");
        },
      });
    }

    if (
      ![
        "Bag",
        "OrderCourier",
        "BagCourier",
        "Notification",
        "NotificationHub",
        "LedgerReport",
      ].includes(entityType)
    ) {
      actions.push({
        icon: <IoEyeOutline style={{ marginRight: "10px" }} />,
        label: "View",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "view");
        },
      });
    }

    const canApproveStationary =
      shouldRenderAuth ||
      shouldRenderEdit ||
      ["ADMK", "ADCK", "ADCH", "MAKER", "CHECKER"].includes(userRole) ||
      isOperationsLogin ||
      isHubLogin;

    if (["BuyStationary"].includes(entityType) && canApproveStationary) {
      const statusUpper = (item?.status || "").toUpperCase();
      if (statusUpper === "PENDING") {
        actions.push({
          icon: <GrValidate style={{ marginRight: "10px" }} />,
          label: "Approve / Reject",
          onClick: (e) => {
            e.stopPropagation();
            handleAction(item, "approve/reject");
          },
        });
      } else if (statusUpper === "APPROVED") {
        actions.push({
          icon: <TbX style={{ marginRight: "10px" }} />,
          label: "Cancel Request",
          onClick: (e) => {
            e.stopPropagation();
            handleAction(item, "approve/reject");
          },
        });
      }
    }

    // 💬 Option: Add / Update Remark for Buy Stationary (only for users with approve permission)
    if (["BuyStationary"].includes(entityType) && canApproveStationary) {
      const hasRemark =
        item?.remarks &&
        typeof item.remarks === "string" &&
        item.remarks.trim() !== "" &&
        item.remarks.trim() !== "-";

      actions.push({
        icon: <EditNoteIcon fontSize="small" style={{ marginRight: "10px" }} />,
        label: hasRemark ? "Update Remark" : "Add Remark",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "remark");
        },
      });
    }

    if (shouldRenderDelete && entityType !== "BuyStationary") {
      actions.push({
        icon: <RiDeleteBinLine style={{ marginRight: "10px" }} />,
        label: entityType !== "Top-up SMS Request" ? "Delete" : "Reject",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "delete");
        },
      });
    }

    if (shouldRenderAuth) {
      actions.push({
        icon: <GrValidate style={{ marginRight: "10px" }} />,
        label:
          entityType !== "Top-up SMS Request" && entityType !== "Top-up Wallet"
            ? "Authorize"
            : "Approve",
        onClick: (e) => {
          e.stopPropagation();
          if (
            entityType === "Company" ||
            entityType === "Franchise" ||
            entityType === "CourierHub" ||
            entityType === "Courier" ||
            entityType === "Top-up Wallet"
          ) {
            handleAction(item, "auth");
          } else {
            handleAuth(item);
          }
        },
      });
    }

    if (
      (["Company"].includes(entityType) && array[72] === 1) ||
      ["Courier"].includes(entityType) ||
      (userRole === "ADMK" && ["Company"].includes(entityType))
    ) {
      actions.push({
        icon: <RiTruckLine style={{ marginRight: "10px" }} />,
        label: "Courier Key",
        onClick: (e) => {
          e.stopPropagation();
          CourierKey(item);
        },
      });
    }

    if (
      (shouldRenderAUDIT &&
        ["Company", "Franchise", "User", "Vendor", "Top-up Wallet"].includes(
          entityType,
        )) ||
      (userRole === "ADMK" && ["Company", "Franchise"].includes(entityType))
    ) {
      actions.push({
        icon: <BsClipboardData style={{ marginRight: "10px" }} />,
        label: "Audit Trail",
        onClick: (e) => {
          e.stopPropagation();
          handleAuditData(item);
        },
      });
    }

    // Mail status and resend (Operation only)
    const emailCode = {
      Company: item?.customerCode,
      Franchise: item?.franchiseCode,
      CourierHub: item?.hubCode,
      User: item?.userId,
    }[entityType];
    if (user?.data?.userProfile === "OPERATION" && emailCode) {
      actions.push({
        icon: <MdOutlineMarkEmailRead style={{ marginRight: "10px" }} />,
        label: "Email Status",
        onClick: (e) => {
          e.stopPropagation();
          setEmailStatusFor({
            code: emailCode,
            title: item?.name || item?.franchiseName || item?.hubName || item?.userName || emailCode,
          });
        },
      });
    }

    if (["Bag"].includes(entityType)) {
      actions.push({
        icon: <AiOutlinePlusCircle style={{ marginRight: "10px" }} />,
        label: "Add Items",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "addItem");
        },
      });
    }

    if (["Bag"].includes(entityType)) {
      actions.push({
        icon: <RiLockLine style={{ marginRight: "10px" }} />,
        label: "Seal",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "seal");
        },
      });
    }

    if (
      ["Company", "Franchise"].includes(entityType) &&
      user?.data?.userProfile !== "CUSTOMER"
    ) {
      actions.push({
        icon: <BiIdCard style={{ marginRight: "10px" }} />,
        label: "Upload Documents",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "upload");
        },
      });
    }

    if (["Notification"].includes(entityType) && userRole === "DELIVERY") {
      actions.push({
        icon: <FaHome style={{ marginRight: "10px" }} />,
        label: "Address",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "address");
        },
      });
    }

    if (
      ["NotificationHub"].includes(entityType) ||
      (entityType === "Notification" &&
        hierarchyType === "MASTER" &&
        item.isSubBag === true)
    ) {
      actions.push({
        icon: <GrUserManager style={{ marginRight: "10px" }} />,
        label: "Assign To Boy",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "assign");
        },
      });
    }

    if (
      ["BagCourier", "NotificationHub", "Notification"].includes(entityType) &&
      ((userRole !== "MAKER" && user?.data?.userProfile === "HUB") ||
        user?.data?.userProfile === "CUSTOMER")
    ) {
      actions.push({
        icon: <GrValidate style={{ marginRight: "10px" }} />,
        label: "Accept To Collect",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "acceptOtp");
        },
      });
    }

    if (
      ["NotificationHub"].includes(entityType) ||
      (entityType === "Notification" &&
        hierarchyType === "MASTER" &&
        item.isSubBag === true)
    ) {
      actions.push({
        icon: <FiCheckCircle style={{ marginRight: "10px" }} />,
        label:
          entityType === "Notification" && hierarchyType === "MASTER"
            ? "Accept By LMBP"
            : "Accept By Hub",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "acceptOtpHub");
        },
      });
    }

    if (["NotificationHub"].includes(entityType)) {
      actions.push({
        icon: <FaBox style={{ marginRight: "10px" }} />,
        label: "Open Bag",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "open");
        },
      });
    }

    // if (
    //   ["OrderCourier", "Order"].includes(entityType) &&
    //   user?.data?.userProfile === "HUB"
    // ) {
    //   actions.push({
    //     icon: <GrValidate style={{ marginRight: "10px" }} />,
    //     label: "Send To OEM",
    //     onClick: (e) => {
    //       e.stopPropagation();
    //       handleAction(item, "send");
    //     },
    //   });
    // }

    if (["LedgerReport"].includes(entityType)) {
      actions.push({
        icon: <TbFileInvoice style={{ marginRight: "10px" }} />,
        label: "Download Receipt",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "downloadReceipt");
        },
      });
    }

    if (
      ["OrderCourier", "Order"].includes(entityType) &&
      user?.data?.userProfile === "HUB"
    ) {
      actions.push({
        icon: <GrSend style={{ marginRight: "10px" }} />,
        label: "Direct Delhivery",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "directToDelhivery");
        },
      });
    }

    if (
      ["OrderCourier", "Order"].includes(entityType) &&
      user?.data?.userProfile === "HUB"
    ) {
      actions.push({
        icon: <GrDeliver style={{ marginRight: "10px" }} />,
        label: "Send To Trackon",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "sendToTrackon");
        },
      });
    }

    if (
      ["OrderCourier", "Order"].includes(entityType) &&
      user?.data?.userProfile === "HUB"
    ) {
      actions.push({
        icon: <FaTruck style={{ marginRight: "10px" }} />,
        label: "Send To Shree Maruti",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "sendToShreeMaruti");
        },
      });
    }

    if (
      ["OrderCourier", "Order"].includes(entityType) &&
      user?.data?.userProfile === "HUB"
    ) {
      actions.push({
        icon: <TbTruckDelivery style={{ marginRight: "10px" }} />,
        label: "Send To Shree Tirupati",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "sendToShreeTirupati");
        },
      });
    }

    if (
      ["Bag"].includes(entityType) ||
      (entityType === "Notification" &&
        hierarchyType === "MASTER" &&
        item.isSubBag === true)
    ) {
      actions.push({
        icon: <RiTruckLine style={{ marginRight: "10px" }} />,
        label: "Notify",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "model");
        },
      });
    }

    if (["Bag"].includes(entityType)) {
      actions.push({
        icon: <RiNotification3Line style={{ marginRight: "10px" }} />,
        label: "Notification",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "notification");
        },
      });
    }

    if (["Bag"].includes(entityType)) {
      actions.push({
        icon: <FaBoxOpen style={{ marginRight: "10px" }} />,
        label: "Unpack Bag",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "unpack");
        },
      });
    }

    if (["Order"].includes(entityType)) {
      actions.push({
        icon: <BsClipboardData style={{ marginRight: "10px" }} />,
        label: "Product Details",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "productDetails");
        },
      });
    }

    if (
      ["Order"].includes(entityType) &&
      user?.data?.userProfile === "HUB" &&
      item.orderStatus === "FAILED"
    ) {
      actions.push({
        icon: <GrRedo style={{ marginRight: "10px" }} />,
        label: "Resend",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "reSend");
        },
      });
    }

    if (["Order"].includes(entityType) && array[125] === 1) {
      actions.push({
        icon: <TbRoute style={{ marginRight: "10px" }} />,
        label: "Track Order",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "trackOrder");
        },
      });
    }

    if (
      ["Order"].includes(entityType) &&
      (userRole === "CUST" || user?.data?.userProfile === "HUB")
    ) {
      actions.push({
        icon: <TbPrinter style={{ marginRight: "10px" }} />,
        label: "Sticker",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "sticker");
        },
      });
    }

    if (
      ["Order"].includes(entityType) &&
      item.orderStatus === "SENT" &&
      user?.data?.userProfile === "HUB"
    ) {
      actions.push({
        icon: <TbFileInvoice style={{ marginRight: "10px" }} />,
        label: "Print Label",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "printLabel");
        },
      });
    }

    if (["Order"].includes(entityType)) {
      actions.push({
        icon: <TbMapPin style={{ marginRight: "10px" }} />,
        label: "Map WayBill No",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "mapTrackId");
        },
      });
    }

    if (["Order"].includes(entityType)) {
      actions.push({
        icon: <TbFileInvoice style={{ marginRight: "10px" }} />,
        label: "Download Invoice",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "downloadInvoice");
        },
      });
    }

    if (
      ["Order"].includes(entityType) &&
      item.orderStatus !== "SENT" &&
      item.orderStatus !== "CANCELLED" &&
      (userRole === "CUST" || user?.data?.userProfile === "HUB")
    ) {
      actions.push({
        icon: <TbX style={{ marginRight: "10px" }} />,
        label: "Cancel Order",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "cancelOrder");
        },
      });
    }

    if (
      ["Order"].includes(entityType) &&
      user?.data?.userProfile === "OPERATION" &&
      item.orderStatus === "SENT"
    ) {
      actions.push({
        icon: <TbX style={{ marginRight: "10px" }} />,
        label: "Cancel Request",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "cancelOrder");
        },
      });
    }

    if (entityType === "ChargeMaster") {
      return [
        {
          icon: <BiEditAlt style={{ marginRight: "10px" }} />,
          label: "Edit",
          onClick: (e) => {
            e.stopPropagation();
            handleAction(item, "modify");
          },
        },
        {
          icon: <IoEyeOutline style={{ marginRight: "10px" }} />,
          label: "View",
          onClick: (e) => {
            e.stopPropagation();
            handleAction(item, "view");
          },
        },
        {
          icon: <RiDeleteBinLine style={{ marginRight: "10px" }} />,
          label: "Delete",
          onClick: (e) => {
            e.stopPropagation();
            handleAction(item, "delete");
          },
        },
      ];
    }

    return actions;
  };

  const handleAttachmentClick = (base64String) => {
    const imageSrc = `data:image/jpeg;base64,${base64String}`;

    let scale = 1;

    const handleZoom = (event) => {
      event.preventDefault();
      const zoomImage = document.getElementById("zoomable-image");
      if (!zoomImage) return;

      const rect = zoomImage.getBoundingClientRect();

      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;

      const originX = (offsetX / rect.width) * 100;
      const originY = (offsetY / rect.height) * 100;

      zoomImage.style.transformOrigin = `${originX}% ${originY}%`;

      if (event.deltaY < 0) {
        scale += 0.1;
      } else {
        scale = Math.max(1, scale - 0.1);
      }

      zoomImage.style.transform = `scale(${scale})`;
    };

    Swal.fire({
      html: `
        <div style="position: relative; overflow: hidden; max-width: 100%; text-align: center;">
          <img 
            src="${imageSrc}" 
            alt="Attachment Image" 
            id="zoomable-image" 
            style="max-width: 80%; transition: transform 0.3s ease;"
          />
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        image: "swal-custom-image",
      },
      willOpen: () => {
        const zoomImage = document.getElementById("zoomable-image");
        zoomImage?.addEventListener("wheel", handleZoom);
      },
      willClose: () => {
        const zoomImage = document.getElementById("zoomable-image");
        zoomImage?.removeEventListener("wheel", handleZoom);
      },
    });
  };

  const getTooltipValue = (value) => {
    if (value === null || value === undefined || value === "") return "";
    let strValue;
    if (Array.isArray(value)) {
      const filtered = value
        .filter((v) => typeof v !== "object" || v === null)
        .map((v) => String(v))
        .join(", ");
      strValue = filtered;
    } else if (typeof value === "object") {
      try {
        strValue = JSON.stringify(value);
      } catch (e) {
        strValue = "[Invalid Object]";
      }
    } else {
      strValue = String(value);
    }
    // Additional cleanup if needed
    strValue = strValue
      .replace(/,\s*\[object Object\]/g, ",")
      .replace(/\[object Object\],\s*/g, ", ")
      .replace(/\[object Object\]/g, "");
    return strValue.trim();
  };

  const downloadFile = async (url, id) => {
    try {
      const response = await fetch(url, {
        method: "GET",
      });

      const blob = await response.blob();
      const fileURL = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = fileURL;
      link.download = `barcode_${id}.pdf`; // file name
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleDownloadFile = (url, id) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="w-full flex flex-col gap-y-2">
      {loading ? (
        <div className="flex items-center justify-center h-[300px]">
          <Loader />
        </div>
      ) : (
        <>
          {/* HEADER SECTION */}
          {entityType !== "Download Report" && (
            <div className="flex flex-wrap items-center justify-between gap-3 pt-3">
              <div className="flex flex-wrap gap-2">
                {(entityType === "Payment History" ||
                  entityType === "Report" ||
                  entityType === "Ledger") && (
                  <>
                    {entityType === "Payment History" ? (
                      <button
                        className="btn addUser"
                        onClick={() => handleAction(null, "report")}
                      >
                        Report Type
                      </button>
                    ) : (
                      <button
                        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-orange-500 text-white font-medium shadow hover:bg-orange-600 transition"
                        onClick={
                          entityType === "RCS Transaction"
                            ? openModalRcs
                            : openModalSms
                        }
                      >
                        Full Statement
                      </button>
                    )}

                    <button
                      className="flex items-center gap-2 px-4 py-2 rounded-lg bg-orange-500 text-white font-medium shadow hover:bg-orange-600 transition"
                      onClick={
                        entityType === "RCS Transaction"
                          ? openModalRcsDown
                          : openModalSmsDown
                      }
                    >
                      Download Report
                    </button>
                  </>
                )}

                {isOperationsLogin && entityType === "BuyStationary" && (
                  <button
                    className="btn addUser"
                    onClick={() => handleAction(null, "generateReport")}
                  >
                    AWB Sticker
                    <TbDownload />
                  </button>
                )}

                {entityType === "ChargeMaster" && (
                  <button
                    className="btn addUser"
                    onClick={() => handleAction(null, "openModal")}
                  >
                    {modalBtnName ? modalBtnName : "Find Category"}
                  </button>
                )}

                {userRole === "CUST" &&
                  entityType === "LedgerReport" &&
                  headerInfo && (
                    <div className="bg-orange-50 border border-orange-200 rounded-xl px-4 py-3 flex flex-wrap gap-6 text-sm shadow-sm">
                      {Object.entries(headerInfo).map(([label, value]) => (
                        <div key={label} className="flex items-center gap-2">
                          <span className="text-gray-500 font-medium">
                            {label} :
                          </span>
                          <span className="text-gray-800 font-semibold">
                            {value || "-"}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}

                {[
                  "CustomerEnquiries",
                  "Order",
                  "LedgerReport",
                  "User",
                  "Company",
                  "CourierHub",
                ].includes(entityType) && (
                  <button
                    className="btn addUser"
                    onClick={handleExport}
                    disabled={exportLoading}
                  >
                    {exportLoading ? "Downloading..." : "Excel Download"}
                  </button>
                )}

                {entityType === "Report" && (
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button className="btn addUser" onClick={openModalIpWhit}>
                      IP Whitelisting
                    </button>
                    {userRole === "CUST" && (
                      <button
                        className="btn addUser"
                        onClick={() => handleAction("", "recharge")}
                      >
                        Recharge
                      </button>
                    )}
                  </div>
                )}
              </div>

              {/* SORT */}
              <div className="flex items-center gap-2">
                {/* Screens with their own on-page filter bar hide the pop-up filter controls */}
                {!hideFilterControls && (entityType === "Company" ||
                  entityType === "CourierHub" ||
                  entityType === "User" ||
                  entityType === "Top-up Wallet" ||
                  entityType === "Report" ||
                  entityType === "Courier" ||
                  entityType === "Order" ||
                  entityType === "Report Order" ||
                  entityType === "SMS Transaction" ||
                  entityType === "RCS Transaction" ||
                  entityType === "Ledger" ||
                  entityType === "LedgerReport" ||
                  entityType === "Notification" ||
                  entityType === "Vendor" ||
                  entityType === "Role" ||
                  entityType === "Wallet Activity" ||
                  entityType === "Top-up SMS Request" ||
                  entityType === "Buy SMS" ||
                  entityType === "Bulk Upload" ||
                  entityType === "Vendor Txt History" ||
                  entityType === "ReportCourier" ||
                  entityType === "CustomerEnquiries" ||
                  entityType === "Bag" ||
                  entityType === "Franchise" ||
                  entityType === "Payment History" ||
                  entityType === "BuyStationary" ||
                  entityType === "ChargeMaster" ||
                  entityType === "Delivery" ||
                  entityType === "OrderCourier" ||
                  entityType === "BagCourier" ||
                  entityType === "Pickup Address" ||
                  entityType === "RateCardMaster" ||
                  entityType === "GenerateSticker") && (
                  // entityType === "SMS Master") By omkar
                  <div className="filter-container">
                    {showFilters && (
                      <motion.div
                        initial={{ x: "100%", opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: "100%", opacity: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div
                          className="search-btn"
                          onClick={openModalFilter}
                          style={{ cursor: "pointer" }}
                        >
                          Search/Filter
                        </div>
                      </motion.div>
                    )}

                    {showFilters && (
                      <motion.div
                        initial={{ x: "100%", opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: "100%", opacity: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div
                          className="green-btn"
                          onClick={handleToggle}
                          style={{ cursor: "pointer" }}
                        >
                          {/* <CachedIcon /> */}
                          <img
                            src={reload} // 👈 your reload image path
                            alt="reload"
                            className="w-5 h-5" // adjust size
                          />
                        </div>
                      </motion.div>
                    )}
                    <div className="filter-toggle-box">
                      <img
                        src={FilterImg}
                        alt="funnel"
                        className="funnel-icon"
                        onClick={toggleFilters}
                        style={{ cursor: "pointer" }}
                      />
                      <div
                        className={`filter-text ${
                          filterData &&
                          Object.keys(filterData).length > 0 &&
                          showFilters
                            ? "pr-1"
                            : ""
                        }`}
                      >
                        {filterData &&
                          (entityType === "Company"
                            ? CompanyformatFilterDisplay(filterData)
                            : entityType === "Franchise"
                            ? FranchiseformatFilterDisplay(filterData)
                            : entityType === "BuyStationary"
                            ? BuyStationaryformatFilterDisplay(filterData)
                            : entityType === "Courier Hub"
                            ? CourierHubformatFilterDisplay(filterData)
                            : entityType === "User"
                            ? UserformatFilterDisplay(filterData)
                            : entityType === "Top-up Wallet"
                            ? MWalletformatFilterDisplay(filterData)
                            : entityType === "Report"
                            ? ReportformatFilterDisplay(filterData)
                            : entityType === "Order"
                            ? OrderformatFilterDisplay(filterData)
                            : entityType === "Ledger"
                            ? LedgerformatFilterDisplay(filterData)
                            : entityType === "LedgerReport"
                            ? LedgerReportformatFilterDisplay(filterData)
                            : entityType === "Notification"
                            ? NotificationformatFilterDisplay(filterData)
                            : entityType === "Courier"
                            ? CourierformatFilterDisplay(filterData)
                            : entityType === "SMS Transaction"
                            ? SMSformatFilterDisplay(filterData)
                            : entityType === "RCS Transaction"
                            ? RCSformatFilterDisplay(filterData)
                            : entityType === "Vendor"
                            ? VendorformatFilterDisplay(filterData)
                            : entityType === "Role"
                            ? RoleformatFilterDisplay(filterData)
                            : entityType === "Buy SMS"
                            ? BuySMSformatFilterDisplay(filterData)
                            : entityType === "Top-up SMS Request"
                            ? TopupSMSformatFilterDisplay(filterData)
                            : entityType === "Bulk Upload"
                            ? BulkUploadformatFilterDisplay(filterData)
                            : entityType === "Vendor Txt History"
                            ? VendorTxtHistoryformatFilterDisplay(filterData)
                            : entityType === "CustomerEnquiries"
                            ? CustomerEnquiriesformatFilterDisplay(filterData)
                            : entityType === "Bag"
                            ? BagformatFilterDisplay(filterData)
                            : entityType === "CourierHub"
                            ? CourierHubFilterDisplay(filterData)
                            : entityType === "Payment History"
                            ? PaymentHistoryFilterDisplay(filterData)
                            : entityType === "ChargeMaster"
                            ? ChargeMasterFilterDisplay(filterData)
                            : entityType === "Delivery"
                            ? DeliveryformatFilterDisplay(filterData)
                            : entityType === "OrderCourier"
                            ? OrderCourierformatFilterDisplay(filterData)
                            : entityType === "BagCourier"
                            ? BagCourierformatFilterDisplay(filterData)
                            : entityType === "Pickup Address"
                            ? PickupAddressformatFilterDisplay(filterData)
                            : entityType === "RateCardMaster"
                            ? RateCardformatFilterDisplay(filterData)
                            : entityType === "GenerateSticker"
                            ? GenerateStickerformatFilterDisplay(filterData)
                            : null)}
                      </div>
                    </div>

                    {/* RCS ICON */}
                    {entityType === "RCS Transaction" && (
                      <Tooltip
                        title={"RCS Dashboard"}
                        arrow
                        slotProps={{
                          popper: {
                            sx: {
                              "& .MuiTooltip-tooltip": {
                                fontSize: "16px", // bigger text
                                padding: "12px 20px", // more padding = taller tooltip
                                minHeight: "40px", // force height
                              },
                              "& .MuiTooltip-arrow": {
                                fontSize: "1.2em", // bigger arrow
                              },
                            },
                          },
                        }}
                      >
                        <img
                          src={ExcelExport}
                          alt="RCS"
                          style={{
                            width: "40px",
                            height: "40px",
                            cursor: "pointer",
                          }}
                          onClick={openModalRcsNew}
                        />
                      </Tooltip>
                    )}
                  </div>
                )}
                {!(
                  entityType === "Pickup Address" &&
                  user?.data?.userProfile === "HUB" &&
                  Array.isArray(data) &&
                  data.length > 0
                ) &&
                  ((shouldRenderCreate &&
                    entityType !== "BagCourier" &&
                    entityType !== "GenerateSticker") ||
                    entityType === "ChargeMaster") && (
                    <Button
                      label={btnName || "Add"}
                      icon={AddIcon}
                      onClick={() => handleAction("", "add")}
                    />
                  )}
                <select
                  className="sort-select appearance-none pr-10 !border !border-[#DDDDDD]"
                  value={sortOrder}
                  onChange={(e) => handleSortChange(e, filterFields)}
                >
                  <option value="" disabled>
                    Sort by Name
                  </option>
                  <option value="asc">Ascending</option>
                  <option value="des">Descending</option>
                </select>
              </div>
            </div>
          )}

          {/* TABLE CARD */}
          <div className="w-full bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
            <div className="overflow-x-auto max-h-[69vh] custom-scrollbar">
              <table className="min-w-full text-sm text-gray-700">
                {/* HEADER */}
                <thead className="sticky top-0 z-10 !bg-[#ffe8d4] shadow-sm">
                  <tr>
                    {entityType !== "ReportCourier" && (
                      <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide text-center whitespace-nowrap">
                        Sr No
                      </th>
                    )}

                    {![
                      "Buy SMS",
                      "Top-up SMS",
                      "SMS Transaction",
                      "RCS Transaction",
                      "SMS Master",
                      "Bulk Upload",
                      "Vegaah Bulk Upload",
                      "Report",
                      "Ledger",
                      "CustomerEnquiries",
                      "Vendor Txt History",
                      "Report Order",
                      "GenerateSticker",
                      "Payment History",
                    ].includes(entityType) &&
                      hideAction !== "hideAction" && (
                        <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide text-center whitespace-nowrap">
                          Actions
                        </th>
                      )}

                    {headers?.map((header, index) => (
                      <th
                        key={index}
                        className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>

                {/* BODY */}
                <tbody>
                  {noData ? (
                    <tr>
                      <td
                        colSpan={headers.length + 1}
                        className="px-4 py-6 text-center font-semibold text-gray-500"
                      >
                        No data available
                      </td>
                    </tr>
                  ) : (
                    sortedData?.map((item, index) => (
                      <tr
                        key={item.id}
                        className="border-b hover:bg-orange-50 transition duration-200"
                      >
                        {entityType !== "ReportCourier" && (
                          <td className="px-4 py-3 text-center font-medium">
                            {(pageDetails.pageNo - 1) * pageDetails.pageSize +
                              index +
                              1}
                          </td>
                        )}

                        {/* Action */}
                        {![
                          "Buy SMS",
                          "Top-up SMS",
                          "SMS Transaction",
                          "RCS Transaction",
                          "SMS Master",
                          "Bulk Upload",
                          "Vegaah Bulk Upload",
                          "Report",
                          "Ledger",
                          "CustomerEnquiries",
                          "Vendor Txt History",
                          "Report Order",
                          "GenerateSticker",
                          "Payment History",
                        ].includes(entityType) &&
                          hideAction !== "hideAction" && (
                            <td className="px-4 py-3 text-center">
                              <Popover>
                                {({ close }) => (
                                  <>
                                    <PopoverButton className="p-2 rounded-md hover:bg-gray-100 transition text-gray-600">
                                      ⋮
                                    </PopoverButton>

                                    <Transition
                                      enter="transition ease-out duration-200"
                                      enterFrom="opacity-0 translate-y-1"
                                      enterTo="opacity-100 translate-y-0"
                                      leave="transition ease-in duration-150"
                                      leaveFrom="opacity-100 translate-y-0"
                                      leaveTo="opacity-0 translate-y-1"
                                    >
                                      <PopoverPanel
                                        portal
                                        anchor={{ to: "bottom start", gap: 8 }}
                                        className="z-[9999] min-w-[220px] rounded-xl border border-gray-200 bg-white shadow-xl py-2"
                                      >
                                        {getActionItems(item).map(
                                          (action, idx) => (
                                            <div
                                              key={idx}
                                              className="flex items-center gap-2 px-3 py-2 text-sm font-medium cursor-pointer hover:bg-gray-100"
                                              onClick={(e) => {
                                                action.onClick(e);
                                                close();
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.currentTarget.style.backgroundColor =
                                                  "#f0f0f0")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.currentTarget.style.backgroundColor =
                                                  "#ffffff")
                                              }
                                            >
                                              {action.icon}
                                              <span>{action.label}</span>
                                            </div>
                                          ),
                                        )}
                                      </PopoverPanel>
                                    </Transition>
                                  </>
                                )}
                              </Popover>
                            </td>
                          )}

                        {/* {headers?.map((header, idx) => {
                        const dataKey = headerToKeyMap[header];
                        const value = item[dataKey];

                        return (
                          <td
                            key={idx}
                            className="px-4 py-3 whitespace-nowrap text-sm"
                          >
                            {value || value === 0 ? value : "-"}
                          </td>
                        );
                      })} */}

                        {headers?.map((header, idx) => {
                          const dataKey = headerToKeyMap[header];
                          const value = item[dataKey];
                          const fullAddress = [
                            item.address1,
                            item.address2,
                            item.address3,
                            item.pincode,
                            item.city,
                            item.state,
                            item.country,
                          ]
                            .filter(
                              (component) =>
                                component != null && component !== "",
                            )
                            .join(", ");
                          const maxDisplayLength = 14;
                          const smsDisplayLength = 36;

                          return (
                            <td
                              key={idx}
                              className="px-4 py-3 whitespace-nowrap text-sm"
                            >
                              {dataKey === "fileUrl" ? (
                                (item.status === "Completed" ||
                                  item.status === "COMPLETED") &&
                                value ? (
                                  <GetAppIcon
                                    style={{
                                      color: "#14b8a6",
                                      cursor: "pointer",
                                      fontSize: "28px",
                                      verticalAlign: "middle",
                                    }}
                                    title="Download File"
                                    onClick={() =>
                                      entityType === "Download Report"
                                        ? handleDownloadFile(value, item.id)
                                        : downloadFile(value, item.id)
                                    }
                                  />
                                ) : (
                                  "-"
                                )
                              ) : (dataKey === "remark" ||
                                  dataKey === "emailId" ||
                                  dataKey === "remarks") &&
                                item[dataKey] ? (
                                item[dataKey] === "-" ? (
                                  "-"
                                ) : item[dataKey].length > 15 ? (
                                  <>
                                    {item[dataKey].substring(0, 15)}...
                                    <div
                                      className="text-[#00B6CE] underline cursor-pointer"
                                      title="View full content"
                                      onClick={() =>
                                        showFullContent(item[dataKey], dataKey)
                                      }
                                    >
                                      View More
                                    </div>
                                  </>
                                ) : (
                                  item[dataKey]
                                )
                              ) : (dataKey === "address" ||
                                  dataKey === "consigneeFullAddress") &&
                                item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <div
                                    className="text-[#00B6CE] underline cursor-pointer"
                                    title="View full content"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                  >
                                    View More
                                  </div>
                                </>
                              ) : dataKey === "responseDescription" &&
                                item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <div
                                    className="text-[#00B6CE] underline cursor-pointer"
                                    title="View full content"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                  >
                                    View More
                                  </div>
                                </>
                              ) : dataKey === "response" && item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <div
                                    className="text-[#00B6CE] underline cursor-pointer"
                                    title="View full content"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                  >
                                    View More
                                  </div>
                                </>
                              ) : dataKey === "utrNo" &&
                                item[dataKey] &&
                                entityType !== "Top-up Wallet" ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <div
                                    className="text-[#00B6CE] underline cursor-pointer"
                                    title="View full content"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                  >
                                    View More
                                  </div>
                                </>
                              ) : (dataKey === "narration" ||
                                  dataKey === "fullAddress" ||
                                  dataKey === "fileName" ||
                                  (dataKey === "ewaybillNumber" &&
                                    entityType === "LedgerReport")) &&
                                item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 15)}...
                                  <div
                                    className="text-[#00B6CE] underline cursor-pointer"
                                    title="View full content"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                  >
                                    View More
                                  </div>
                                </>
                              ) : dataKey === "attachment" && item[dataKey] ? (
                                <>
                                  <GrAttachment
                                    className="icon-spacing"
                                    title="View Attachment"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleAttachmentClick(item[dataKey])
                                    }
                                  />
                                </>
                              ) : [
                                  "authStatus",
                                  "status",
                                  "billerStatus",
                                  "orderStatus",
                                  "courierSend",
                                ].includes(dataKey) ? (
                                <button
                                  type="button"
                                  className={`status-button ${
                                    [
                                      "ACTIVE",
                                      "SUCCESS",
                                      "COMPLETED",
                                      "SEND",
                                      "APPROVED",
                                      "Completed",
                                      "Success",
                                      "submitted",
                                      "SENT",
                                      "DELIVERED",
                                      "ACCEPTED",
                                      "MESSAGE_DELIVERED",
                                      "SEND_MESSAGE_SUCCESS",
                                      "MESSAGE_READ",
                                      "MESSAGE_CLICK",
                                      "Accepted By Courier Hub",
                                      "ACCEPTED_BY_HUB",
                                    ].includes(item[dataKey])
                                      ? "button-success"
                                      : [
                                          "IN-ACTIVE",
                                          "BLOCK",
                                          "FAIL",
                                          "REJECTED",
                                          "Failed",
                                          "FAILED",
                                          "DECLINED",
                                          "UNREACHABLE_USER",
                                          "SEND_MESSAGE_FAILURE",
                                          "EXCEPTION",
                                          "Closed",
                                          "SEALED",
                                          "CANCELLED",
                                        ].includes(item[dataKey])
                                      ? "button-danger"
                                      : item[dataKey] === "INPROGRESS" ||
                                        item[dataKey] === "Processing" ||
                                        item[dataKey] === "PENDING_TMID" ||
                                        item[dataKey] === "PENDING" ||
                                        item[dataKey] === "SENT_TO_CUSTOMER" ||
                                        item[dataKey] === "In Transit" ||
                                        item[dataKey] === "NOTIFIED_HUB" ||
                                        item[dataKey] === "READY_TO_SEND"
                                      ? "button-warning"
                                      : "button-secondary"
                                  }`}
                                  style={{
                                    borderRadius: "20px",
                                    padding: "2px 10px",
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "50%",
                                      display: "inline-block",
                                    }}
                                  />
                                  {item[dataKey] || item[dataKey] === 0
                                    ? item[dataKey]
                                    : "-"}
                                </button>
                              ) : dataKey === "address" ? (
                                <span
                                  className="address-shortened"
                                  title={fullAddress}
                                >
                                  {fullAddress.length > maxDisplayLength
                                    ? `${fullAddress.substring(
                                        0,
                                        maxDisplayLength,
                                      )}...`
                                    : fullAddress}
                                </span>
                              ) : dataKey === "download" ? (
                                <>
                                  <img
                                    src={ICONS.DownloadCsvIcon}
                                    alt="DownloadIcon"
                                    onClick={() => setRowData(item)}
                                    style={{ width: "20px", cursor: "pointer" }}
                                  />
                                </>
                              ) : dataKey === "process" ? (
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-submit !rounded-[10px] w-[100px] h-[21px]  font-medium !p-0 text-[14px]"
                                    onClick={() =>
                                      handleAction(item, "process")
                                    }
                                  >
                                    Process
                                  </button>
                                </>
                              ) : dataKey === "products" ? (
                                <>
                                  <FiEye
                                    className="icon-spacing"
                                    title="Product Details"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setRowData(item);
                                      handleProductDetails(item);
                                    }}
                                  />
                                </>
                              ) : header === "Option" ? (
                                <span
                                  ref={(el) => {
                                    if (el && item?.id != null) {
                                      optionRefs.current[item.id] = el;
                                    }
                                  }}
                                  className="icon-spacing"
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                  title="More Options"
                                  onClick={(e) =>
                                    handleAction(item, "moreOptions")
                                  }
                                >
                                  ⋮
                                </span>
                              ) : value || value === 0 ? (
                                value
                              ) : (
                                "-"
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <DetailModal
            open={detailModal}
            onClose={() => setDetailModal(false)}
            text={modalText}
            headingText={modalHeading || "Details"}
          />

          {emailStatusFor && (
            <EmailStatusModal
              code={emailStatusFor.code}
              title={emailStatusFor.title}
              onClose={() => setEmailStatusFor(null)}
            />
          )}

          {/* PAGINATION */}
          {!noData && (
            <Pagination
              currentPage={currentPage}
              totalCount={totalRecord}
              pageSize={pageSize}
              onPageChange={(page) => {
                setCurrentPage(page);
                fetchNextData(page, pageSize);
              }}
              onPageSizeChange={(newSize) => {
                setPageSize(newSize);
                setCurrentPage(1);
                fetchNextData(1, newSize);
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default MasterTable;
